// receive & request data
export const REQUEST_DATA = 'REQUEST_DATA';
export const DISPLAY_LOADING_WARNING = 'DISPLAY_LOADING_WARNING';
export const RECEIVE_DATA = 'RECEIVE_DATA';
export const RECEIVE_DATA_ERROR = 'RECEIVE_DATA_ERROR';
// This action type is dispatched when history receives a location change
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
// This action type will be dispatched by the history actions below.
export const CALL_HISTORY_METHOD = 'CALL_HISTORY_METHOD';
// This action type handles categories selections
export const CATEGORY_TOGGLE = 'CATEGORY_TOGGLE';
// This action type handles categories selections
export const SELECTED_CATEGORIES_CHANGE = 'SELECTED_CATEGORIES_CHANGE';
// This action type handles data reset
export const RESET_DATA = 'RESET_DATA';
// This handles print mode
export const PRINT_MODE = 'PRINT_MODE';
// These actions relate to table interactions
export const YEAR_CHANGE = 'YEAR_CHANGE';
export const DATAVIEW_CHANGE = 'DATAVIEW_CHANGE';
export const CHARACTERISTIC_TOGGLE = 'CHARACTERISTIC_TOGGLE';

export const REQUEST_SHORT_URL = 'REQUEST_SHORT_URL';
export const RECEIVE_SHORT_URL = 'RECEIVE_SHORT_URL';

export const TABLE_COLUMN_ORDER_CHANGE = 'TABLE_COLUMN_ORDER_CHANGE';

export default {
  REQUEST_DATA,
  RECEIVE_DATA,
  RECEIVE_DATA_ERROR,
  DISPLAY_LOADING_WARNING,
  LOCATION_CHANGE,
  CALL_HISTORY_METHOD,
  CATEGORY_TOGGLE,
  SELECTED_CATEGORIES_CHANGE,
  RESET_DATA,
  PRINT_MODE,
  YEAR_CHANGE,
  DATAVIEW_CHANGE,
  CHARACTERISTIC_TOGGLE,
  REQUEST_SHORT_URL,
  RECEIVE_SHORT_URL,
  TABLE_COLUMN_ORDER_CHANGE,
};



// WEBPACK FOOTER //
// ./app/config/types.js